// Core version + navigation, pagination, autoplay modules
import Swiper from 'swiper'
import { Pagination, Autoplay } from 'swiper/modules'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/pagination'

// Initialize Swiper when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
	// Possibilities Section Swiper
	const possibilitiesSwiper = new Swiper('.possibilities__cards', {
		// Configure Swiper to use modules
		modules: [Pagination, Autoplay],

		// Basic settings
		slidesPerView: 1,
		slidesPerGroup: 1, // Przesuwa 2 slajdy naraz
		spaceBetween: 20,
		loop: true,
		grabCursor: true,
		autoHeight: true,

		// Autoplay settings
		autoplay: {
			delay: 5000, // 5 sekund
			disableOnInteraction: false, // Kontynuuj po interakcji
			pauseOnMouseEnter: true, // Pauza po najechaniu myszką
		},

		// Responsive breakpoints
		breakpoints: {
			// Mobile - po 1 slajdzie, przesuwa 2
			640: {
				slidesPerView: 1,
				slidesPerGroup: 2,
				spaceBetween: 20,
			},
			// Tablet - pokazuje 2, przesuwa 2
			1025: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 24,
			},
		},

		// Pagination bullets
		pagination: {
			el: '.possibilities__pagination',
			clickable: true,
		},

		// Keyboard control
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},

		// Mouse wheel control
		mousewheel: {
			forceToAxis: true,
		},

		// Accessibility
		a11y: {
			enabled: true,
			prevSlideMessage: 'Poprzedni slajd',
			nextSlideMessage: 'Następny slajd',
			paginationBulletMessage: 'Przejdź do slajdu {{index}}',
		},

		// Events
		on: {
			init: function () {
				console.log('Possibilities Swiper initialized')
			},
			slideChange: function () {
				console.log('Slide changed to:', this.activeIndex)
			},
		},
	})

	// Testimonials Swiper (te same parametry co possibilities)
	const testimonialsSwiper = new Swiper('.testimonials__cards', {
		modules: [Pagination, Autoplay],

		slidesPerView: 1,
		slidesPerGroup: 1,
		loop: true,
		grabCursor: true,
		autoHeight: true,
		spaceBetween: 30,

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		breakpoints: {
			640: {
				slidesPerView: 2,
				slidesPerGroup: 1,
			},
			1025: {
				slidesPerView: 3,
				slidesPerGroup: 1,
			},
		},

		pagination: {
			el: '.testimonials__pagination',
			clickable: true,
		},

		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},

		mousewheel: {
			forceToAxis: true,
		},

		a11y: {
			enabled: true,
			prevSlideMessage: 'Poprzedni slajd',
			nextSlideMessage: 'Następny slajd',
			paginationBulletMessage: 'Przejdź do slajdu {{index}}',
		},

		on: {
			init: function () {
				console.log('Testimonials Swiper initialized')
			},
		},
	})
})
